import React from "react";
import "./How_It_Works.css";
import How_It_Works_card from "../../../Common_Component/How_It_Works_card/How_It_Works_card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function How_It_Works() {
  return (
    <>
      <section className="How_It_Works">
        <div className="container">
          <div className="heading_holder">
            <h4>How It Works</h4>
          </div>
          <Swiper
            className="mySwiper"
            slidesPerView={5}
            spaceBetween={10}
            breakpoints={{
              320: {
                // For screens 320px and up
                slidesPerView: 2,
                spaceBetween: 10,
              },
              480: {
                // For screens 480px and up
                slidesPerView: 2,
                spaceBetween: 15,
              },
              768: {
                // For screens 768px and up
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                // For screens 1024px and up
                slidesPerView: 4,
                spaceBetween: 25,
              },
              1200: {
                // For screens 1200px and up
                slidesPerView: 5,
                spaceBetween: 30,
              },
            }}
          >
            <SwiperSlide>
              <How_It_Works_card
                numberText={"1"}
                headingText={"Understanding Your Goals"}
                text={
                  "We discuss your campaign objectives, target audience, and preferred locations."
                }
              />
            </SwiperSlide>

            <SwiperSlide>
              <How_It_Works_card
                numberText={"2"}
                headingText={"Concept Design"}
                text={
                  "Create visually striking & message-driven billboard designs tailored to your brand and campaign."
                }
              />
            </SwiperSlide>
            <SwiperSlide>
              <How_It_Works_card
                numberText={"3"}
                headingText={"Strategic Placement"}
                text={
                  "Identify prime locations with high footfall or traffic to maximize visibility."
                }
              />
            </SwiperSlide>

            <SwiperSlide>
              <How_It_Works_card
                numberText={"4"}
                headingText={"Fabrication and Installation"}
                text={
                  "Handle the printing, fabrication, and seamless installation of your billboard or hoarding."
                }
              />
            </SwiperSlide>

            <SwiperSlide>
              <How_It_Works_card
                numberText={"5"}
                headingText={"Campaign Monitoring"}
                text={
                  "Track performance and provide insights to measure the impact of your outdoor campaign."
                }
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default How_It_Works;
